'use client'

import banner from "@/public/image/banner/m_banner.png"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useContext, useEffect, useMemo, useState } from "react";
import { BannerContext, bannerTypes } from "@/context/bannerContext";
import { Autoplay } from "swiper/modules";
import { useNav } from "@/context/navContext";
import { isValidUrl } from "@/util/testUrlReg";
import { webShare } from "@/util/webShare";


export default function MoBanner({banners,ratio}: {banners: any[],ratio?:string}) {
    const {movePage} = useNav()

    function bannerClickEventHandlr(redirect_url: string){
        if(isValidUrl(redirect_url)){
            // url 맞음
            movePage(redirect_url)
        }else{
            // 키값에 따라 스크립트
            switch(redirect_url){
                case "share":
                    const shareInfo = {
                        
                        url: `${window.location.protocol}//${window.location.host}`,
                        title: `[SPON TV] 스폰티비`,
                        description: `중계중에최고 스폰티비`,
                        // imageUrl: streamData.thumbnail
                    }
                    const test = webShare(shareInfo)
                break;
            }
        }
    }

    const mobileBannerSwiper: bannerTypes[] = useMemo(() => {
        if (!banners) return []

        return banners.filter((el) => el.image_url !== '' && el.image_url && el.is_active === true) || []
    }, [banners])

    if(!mobileBannerSwiper?.length) return null;

    return (
        <div className="mo-banner-layout">
            <div className="banner" style={ratio?{aspectRatio:ratio}: {}} >
                {/* <img src={banner.src} alt="mo-banner" /> */}
                <Swiper
                    spaceBetween={10}
                    className="swiper-container"
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    loop
                    modules={[Autoplay]}
                    autoHeight={true} >
                    {
                        mobileBannerSwiper.map((banner, index) => (
                            <SwiperSlide key={index} 
                                         onClick={()=>{ bannerClickEventHandlr(`${banner.redirect_url}`)}}
                                         className={`${banner.redirect_url && 'barogagi'}`}>
                                <img src={banner.image_url} alt={banner.title} />
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </div>
    )
}
